<script>
  import { _ } from 'svelte-i18n'
  import { router } from 'tinro'
  import { logout } from '../utils/ApiUtils.svelte'
  import { mainMenuToggle, userDetails, avatarImageSrc } from './DataStore'

  import TopSearchBar from './TopSearchBar.svelte'

  function openSettings() {
    router.goto('/settings')
  }

  function clickLogout() {
    logout()
    router.goto('/login')
  }

  function sidebarToggle() {
    console.log(444, $mainMenuToggle)
    $mainMenuToggle = !$mainMenuToggle
  }
</script>

<nav class="sb-topnav navbar navbar-expand navbar-light s-navbar">
  <!-- Navbar Brand-->
  <span
    class="navbar-brand ps-3 header-logo"
    on:click={() => router.goto('/')}
  />
  <!-- Sidebar Toggle-->
  <button
    class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 s-sidebartoggle"
    id="sidebarToggle"
    on:click={sidebarToggle}><i class="fas fa-bars" /></button
  >
  <!-- Navbar Search-->
  <TopSearchBar />
  <!-- Navbar-->
  <ul class="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
    <li class="nav-item dropdown no-arrow">
      <span
        class="nav-link"
        id="topNavbarDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img
          alt="avatar"
          class="border rounded-circle img-profile"
          src={$avatarImageSrc}
        /></span
      >
      <ul
        class="dropdown-menu dropdown-menu-end"
        aria-labelledby="topNavbarDropdown"
      >
        <li>
          <span class="dropdown-item" on:click={openSettings}
            ><i class="fas fa-cogs me-2" />{$_('SETTINGS')}</span
          >
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li>
          <span class="dropdown-item" on:click={clickLogout}
            ><i class="fas fa-sign-out-alt me-2" />{$_('LOGOUT')}</span
          >
        </li>
      </ul>
    </li>
  </ul>
</nav>

<style>
  .dropdown-item {
    cursor: pointer;
  }

  .s-navbar {
    background-color: #f0f8f7 !important;
    /* height: 12vh; */
  }

  .header-logo {
    height: 45px;
    width: 185px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='207' height='51' fill='none' viewBox='0 0 207 51'%3E%3Cpath fill='%23FFCC07' d='M57.156 4.136a7.529 7.529 0 0 0-1.444-2.131 7.44 7.44 0 0 0-2.191-1.5A6.583 6.583 0 0 0 51.019 0H19.645a6.263 6.263 0 0 0-2.564.503 7.934 7.934 0 0 0-2.13 1.5 8.47 8.47 0 0 0-1.44 2.132 6.574 6.574 0 0 0-.502 2.503v20.149c-.02.884.151 1.762.503 2.573.35.77.837 1.47 1.439 2.065l.061.062a5.715 5.715 0 0 0 2.07 1.44 6.547 6.547 0 0 0 2.563.503h21.041l8.08 6.765c.113.089 1.105.87 2.003.686.303-.035.58-.187.772-.423a.89.89 0 0 0 .146-.344 6.354 6.354 0 0 0 0-1.881L51 33.412a6.584 6.584 0 0 0 2.502-.504c.8-.365 1.538-.85 2.191-1.44a8.86 8.86 0 0 0 1.444-2.192 6.677 6.677 0 0 0 .499-2.507V6.639a6.672 6.672 0 0 0-.48-2.503Z'/%3E%3Cpath fill='%2300A094' d='M27.866 29.093a7.62 7.62 0 0 1-5.517-2.423 7.787 7.787 0 0 1-2.093-5.861 1.096 1.096 0 0 1 2.187.155 5.58 5.58 0 0 0 1.51 4.2 5.29 5.29 0 0 0 7.868-.032 5.508 5.508 0 0 0 1.472-4.168 1.097 1.097 0 0 1 2.187-.155 7.811 7.811 0 0 1-2.055 5.81 7.63 7.63 0 0 1-5.498 2.47l-.061.004Z'/%3E%3Cpath fill='%2300A094' d='M44.242 10.878a6.816 6.816 0 0 0-.626-1.157 6.59 6.59 0 0 0-1.157-1.374 6.344 6.344 0 0 0-1.787-1.1 6.615 6.615 0 0 0-2.568-.5H6.711c-.86.001-1.711.17-2.506.5a7.595 7.595 0 0 0-2.192 1.5 7.527 7.527 0 0 0-1.44 2.13c-.33.796-.5 1.648-.502 2.508L0 36.875c.01.856.18 1.704.503 2.498a6.962 6.962 0 0 0 3.631 3.632c.795.328 1.646.5 2.507.503h.625L5.95 48.33a5.536 5.536 0 0 0-.094.503c-.041.254-.05.511-.028.767.015.403.183.785.47 1.068.17.147.377.248.598.292.94.225 1.88-.565 2.003-.687l8.066-6.756H38a6.637 6.637 0 0 0 2.568-.503 6.85 6.85 0 0 0 3.57-3.57 6.644 6.644 0 0 0 .502-2.57l.07-23.489a6.59 6.59 0 0 0-.47-2.507Zm-1.51 25.997a4.484 4.484 0 0 1-.376 1.816 4.846 4.846 0 0 1-1.002 1.505c-.43.46-.969.804-1.566 1.002a4.016 4.016 0 0 1-1.755.376H16.25l-8.334 7 1.943-7.014H6.664a4.03 4.03 0 0 1-1.754-.376 4.19 4.19 0 0 1-1.566-1.002 3.976 3.976 0 0 1-1.002-1.506 4.485 4.485 0 0 1-.376-1.816l.07-23.489a4.485 4.485 0 0 1 .377-1.816c.236-.56.576-1.07 1.001-1.505a5.121 5.121 0 0 1 1.567-1.002 4.03 4.03 0 0 1 1.754-.376h31.37a4.001 4.001 0 0 1 1.753.376 4.482 4.482 0 0 1 1.562 1.016c.425.434.765.945 1.002 1.505.25.573.378 1.191.376 1.816l-.066 23.49ZM128.83 8.652c-3.033 0-5.46 1.115-7.233 3.293-.691-2.48-3.955-3.335-6.885-3.293h-.339l-1.063 4.704h.856c.602 0 1.355-.023 1.773.386.299.36.444.823.405 1.29l.042 19.47h5.286V21.2c0-4.964 2.117-8.045 5.531-8.045 2.789 0 4.205 1.929 4.205 5.73v15.652h5.286V18.343c0-7.146-4.064-9.691-7.864-9.691Zm-26.967-.018c-6.73 0-10.746 4.869-10.746 13.026 0 8.374 4.087 12.984 11.503 12.984 3.264 0 6.439-.889 7.77-1.726l.23-.15-.658-4.47c-1.162.819-4.369 2.22-7.012 2.174-1.04-.052-2.554-.1-3.937-1.148-1.383-1.05-2.28-2.936-2.572-5.58h14.899l.047-.371a31.95 31.95 0 0 0 .188-3.373c0-9.89-6.086-11.366-9.712-11.366Zm-5.418 11.191c.236-3.326 1.411-7.056 5.395-7.056 3.762 0 4.576 3.199 4.576 5.88v1.19l-9.97-.014ZM201.45 8.516l-5.573 20.036-6.339-20.036h-5.644l8.964 27.384a1.64 1.64 0 0 1 0 1.332c-.127.254-.541.828-3.866 1.11a28.97 28.97 0 0 1-2.478.113 1118.6 1118.6 0 0 1 1.053 4.558 19.212 19.212 0 0 0 3.033-.14c.96-.09 1.907-.29 2.822-.593 3.123-1.064 4.449-3.294 5.423-6.502L207 8.492l-5.55.024Zm-20.053 21.123a1.74 1.74 0 0 1-.391-1.27v-12.02c0-4.865-3.358-7.654-9.218-7.654-2.417 0-5.959.47-8.635 1.75l-.272.131.55 4.742.555-.31c1.411-.795 4.562-2.145 7.313-2.145 3.043 0 4.463 1.246 4.463 3.923v2.122l-3.052.047c-7.417.099-10.873 2.653-10.873 8.045 0 4.822 2.991 7.705 7.995 7.705 3.701 0 5.592-1.505 6.49-2.653 1.03 2.329 4.275 2.658 6.006 2.658h.644l1.011-4.704h-.846c-.588.01-1.331.033-1.74-.367Zm-5.686-6.803v2.823c0 4.798-5.028 4.85-5.24 4.85-1.538 0-3.193-1.18-3.193-3.764 0-2.695 1.702-3.82 5.883-3.876l2.55-.033Zm-94.964-3.942c-3.25-1.082-4.402-1.797-4.402-3.655 0-.63 0-2.437 3.438-2.555a5.774 5.774 0 0 1 2.582.348c.677.33.757 1.063.705 2.037l-.028.847 4.726-.88v-.334c.066-1.308.024-2.677-.7-3.791l-.137-.193c-.804-1.153-2.06-1.487-3.057-1.77a12.34 12.34 0 0 0-2.633-.394s-.617-.038-1.181-.038c-5.761 0-9.067 2.592-9.067 7.118 0 5.645 5.239 7.056 8.37 7.884 1.995.523 4.036 1.374 4.036 3.693 0 1.972-1.575 3.054-4.063 3.025-1.613 0-3.344-.343-4.045-.94-.7-.598-.776-.941-.663-2.254l.042-.522-4.75.62-.037.335c-.25 2.3-.085 4.648 3.56 6.115 2.01.607 4.094.932 6.194.965 5.973 0 9.265-2.686 9.265-7.56.019-4.987-3.231-6.44-8.155-8.101Zm69.962 0c-3.245-1.082-4.397-1.797-4.397-3.655 0-.63 0-2.437 3.438-2.555a5.783 5.783 0 0 1 2.582.348c.677.33.757 1.063.705 2.037l-.028.847 4.703-.88v-.334c.066-1.308 0-2.677-.706-3.791l-.136-.193c-.799-1.153-2.055-1.487-3.052-1.77a12.381 12.381 0 0 0-2.634-.394s-.616-.038-1.18-.038c-5.766 0-9.073 2.592-9.073 7.118 0 5.645 5.244 7.056 8.377 7.884 1.994.523 4.03 1.374 4.03 3.693 0 1.972-1.571 3.054-4.059 3.025-1.613 0-3.343-.343-4.044-.94-.701-.598-.776-.941-.668-2.254l.047-.522-4.731.62-.033.335c-.249 2.3-.085 4.648 3.56 6.115 2.007.597 4.087.912 6.18.937 5.977 0 9.265-2.687 9.265-7.56.009-4.959-3.217-6.412-8.146-8.073Z'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: cover;
    margin-left: 3vw;
  }

  .img-profile {
    width: 40px;
    background: #f8f9fa;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
  }
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
  }
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
  }
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .s-sidebartoggle {
      display: none;
    }
  }
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
  }
</style>
